import * as React from "react";
import { useUndo } from "../hooks/useUndo";
import { htmlFromSegments, pasteHtmlAtCaret, simplifyHtmlIntoSegments } from "../utils/html";

let pasteDiv: HTMLElement;

// NOTE: this is not designed to be a form component hooking into useData etc 
// for now keep it freestanding and use the onChange event to update other things

export function EditableRegion(props: {
    className?: string;
    style?: any;
	"data-key"?: any,

	intialHtml?: string,

    id?: string;

    plainText?: boolean;

    ignoreEnter?: boolean;

    undoSupport?: boolean;

    onChange?: (e: any) => void;
    
    onClick?: (e: any) => void;
    
    onFocus?: (e: any) => void;
    onBlur?: (e: any) => void;

    onKeyDown?: (e: any) => boolean;
}) {

	const {
		className,
		id,
		style,
	} = props;

	const ref = React.useRef<any>();

	const undo = useUndo();

    function handlePaste(e: any) {
		debugger;

        // Get pasted data via clipboard API
        const clipboardData = e.clipboardData || (window as any).clipboardData;
        
        const pastedData = 
            props.plainText ?
            clipboardData.getData('text/plain')
            : clipboardData.getData('text/html');


        if (!pasteDiv) {
            pasteDiv = document.createElement("div");
        }
        pasteDiv.innerHTML = pastedData;

        // clean up the html
        const segments = simplifyHtmlIntoSegments(pasteDiv);
        
        // NOTE: often when pasting in from other sources the content is auto set to bold
        // or italic etc but its all the same format, so likely that is handled with 
        // the fact its a heading or something - i.e. set text state on the element
        // so if only 1 segment then ignore whatever the formatting is
        var html;
        if (segments.length === 1) {
            html = segments[0].text;
        } else {
            html = htmlFromSegments(segments);
        }
        pasteHtmlAtCaret(html); //, false);

        handleChange();


        e.preventDefault();
        e.stopPropagation();
        return false;
    }	

    function handleClick(e: any) {
        if (props.onClick) props.onClick(e);
    }

    function handleKeyDown(e: any) {
        if (props.onKeyDown) {
            const result = props.onKeyDown(e);
            if (result === false) return;
        }

        if (e.charCode === 13 && props.ignoreEnter) {
            e.preventDefault();
            return true;
        }

        if (e.ctrlKey || e.metaKey) {
            if (e.keyCode === 66) { //b
                document.execCommand("Bold", false, undefined);
                e.preventDefault();
            } else if (e.keyCode === 73) { //i
                
                // const tmp = rangy.getSelection();
                // console.dir(tmp);

                document.execCommand("Italic", false, undefined);
                e.preventDefault();
            } else if (props.undoSupport && e.keyCode === 90) {
                var newValue;
                if (e.shiftKey) {
                    newValue = undo.redo();
                } else {
                    newValue = undo.undo();
                }
                if (newValue !== undefined) {
                    ref.current.innerHTML = newValue;
                    handleChange();
                }
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }
 
    function handleChange() {
		var html;
        if (props.plainText) {
            html = ref.current.innerText;
        } else {
            html = ref.current.innerHTML;
        }

        if (props.undoSupport) {
            undo.undoPush(html);
        }

		if (html === "<br>") html = "";

        //console.log(html);
        if (props.onChange) {
            // NOTE: don't care if value isn't any different, if this event triggers then always pass it on
            props.onChange({
                target: {
                    value: html,
                }
            });
        }

        //lastHtml = html;
    }	

	const s = (props.intialHtml) ? props.intialHtml : "";

	return (
		<div
			className={[className, "editable-region"].join(" ")}
			ref={ref}
			onInput={handleChange} 
			contentEditable={true}
			dangerouslySetInnerHTML={{__html: s}} 
			onPaste={handlePaste}
			onKeyDown={handleKeyDown}
			id={id}

			data-key={props["data-key"]}

			style={style}

			onClick={handleClick}

			onFocus={props.onFocus}
			onBlur={props.onBlur}
		/>
	);	
}

